import React, { useState, useContext, useEffect } from "react";
import SectionTitle from "../component/SectionTitle";
import { useForm } from "react-hook-form";
import { useSnackbar } from "notistack";
import { useHistory, Redirect, useParams } from "react-router-dom";
import HelmetMetaData from "./HelmetMetaData/HelmetMetaData";

export function ReferenceVerify() {
  const { reftoken } = useParams();
  const { register, handleSubmit, errors, setValue } = useForm();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const [linkExpired, setLinkExpired] = useState(false);
  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    async function checkExpiredLink() {
      try {
        const res = await axios.post("api/reference_verification_check", {
          reftoken: reftoken,
        }, { signal: controller.signal });

        if (!isMounted) return;
        if (res.data.verified == "Y") {
          setLinkExpired(true);
        }
      } catch (error) {
        if (!isMounted) return;
        if (error.name !== "AbortError" && error.name !== "CanceledError") {
          console.error("Failed to verify link:", error);
        }
      }
    }

    checkExpiredLink();
    setValue("type", "seeker");

    // Cleanup: cancel request if component unmounts
        return () => {
      isMounted = false; // ← flip on unmount
      controller.abort();
    };
  }, []);

const onSubmit = async (value) => {
    try {
      const res = await axios.post("api/reference_verification", value);
      enqueueSnackbar(res.data.message, { variant: res.data.status });
      if (res.data.status == "success") {
        history.push("/");
      }
    } catch (error) {
      if (error.name !== "CanceledError") {
        enqueueSnackbar("Something went wrong. Please try again.", {
          variant: "error",
        });
        console.error("Submission failed:", error);
      }
    }
  };

  return (
      <div className="section-full p-t60 p-b0 bg-white">
        <HelmetMetaData />
        <div className="row">
          <div className="col-xl-6 col-lg-6 col-md-6">
            <figure className="account-image">
              <img src="/portal/images/login.png" alt="info image" />
            </figure>
          </div>
          <div className="col-xl-6 col-lg-6 col-md-6">
            {linkExpired ? (
              <div className="text-danger">This link has expired.</div>
            ) : (
              
              <div className="twm-log-reg-form-wrap">
                <SectionTitle lower="Reference Verification" align="center" />
                <form onSubmit={handleSubmit(onSubmit)}
                    className="align-items-center justify-content-center">
                    <input name="token" type="hidden" value={reftoken}  ref={register()}
                    ></input>
                    <p className="twm-log-reg-subtitle">
                        Do you know the candidate?
                    </p>
                    
                    <div className="radio_tabs">
                      <ul>
                        <li>
                            <input type="radio" name="is_verified" className="radio_btn"
                            value="Y" ref={register()} checked /> Yes
                        </li>
                        <li className="active">
                            <input type="radio" name="is_verified" className="radio_btn"
                            value="N" ref={register()} /> No
                        </li>
                      </ul>
                    </div>

                      <div className="form-group mb-3">
                        <label className="mr-3 mb-0 w-1/4 text-sm font-medium text-gray-700">
                          Can you provide more detail about candidate?
                        </label>
                        <textarea
                          name="remarks"
                          placeholder="Enter description"
                          className="form-control" rows={5}
                          ref={register()}
                        />
                      </div>
                      <button type="submit" className="site-button">
                        Submit
                      </button>
                  </form>
              </div>
              
            )}
          </div>
        </div>
      </div>
  );
}
export default ReferenceVerify;
